import { getToken, setToken } from 'utils/auth'
import { userWalletInfo } from 'api/users'
import { formatMoney } from 'utils/utils'
import {getUserInfo} from 'api/users'
import { formatUnixTime } from 'utils/timeformat.js'
const vipTypeMap = {
  1: '月',
  2: '季',
  3: '年'
}
const defaultDubbingParams = {
  dubbing_name: '',
  speaker_id: 1, // 发音人id（app基础请求）
  text: '',
  text_len: 0,
  voice_volume: 1, // 语音音量
  voice_speed: 1, // 语音播放速度（app基础请求）
  voice_delay_time: 3000, // 语音开头静音
  voice_loop_mode: true,  // 语音循环播放
  voice_loop_gap: 5000, // 语音播放间隔
  bgm_name: '', // 背景音乐名称
  bgm_url: '', // 背景音乐url
  bgm_volume: 1, // 背景音乐音量
  bgm_start_time: 3000,  // 背景音乐开始时间
  bgm_volume_down: true, // 背景音乐渐变
  audio_url: '',
  audio_len: 0,
  sample_rate: 24000, // 采样率（app基础请求）
  codec: 'pcm' // 语音文件编码（app基础请求）
}

const state = {
  showBagFlag: false,
  showOrderFlag: false,
  showVipFlag: false,
  loginDialogFlag: !getToken(),
  token: getToken(),
  userInfo: {},
  speakerMap: {},
  dubbingParams: {
    dubbing_name: '',
    speaker_id: 1, // 发音人id（app基础请求）
    text: '',
    text_len: 0,
    voice_volume: 1, // 语音音量
    voice_speed: 1, // 语音播放速度（app基础请求）
    voice_delay_time: 3000, // 语音开头静音
    voice_loop_mode: true,  // 语音循环播放
    voice_loop_gap: 5000, // 语音播放间隔
    bgm_name: '', // 背景音乐名称
    bgm_url: '', // 背景音乐url
    bgm_volume: 1, // 背景音乐音量
    bgm_start_time: 3000,  // 背景音乐开始时间
    bgm_volume_down: true, // 背景音乐渐变
    audio_url: '',
    audio_len: 0,
    sample_rate: 24000, // 采样率（app基础请求）
    codec: 'pcm' // 语音文件编码（app基础请求）
  },
  dubPrice: [],
  regenerateFlag: false,
  walletInfo: {},
  dubbingID: '',
  bagPaid: false
}

const mutations = {
  SET_BAG_FLAG: (state, showBagFlag) => {
    state.showBagFlag =  showBagFlag
  },
  SET_ORDER_FLAG: (state, showOrderFlag) => {
    state.showOrderFlag =  showOrderFlag
  },
  SET_VIP_FLAG: (state, showVipFlag) => {
    state.showVipFlag =  showVipFlag
  },
  SET_LOGIN_DIALOG_FLAG: (state, loginDialogFlag) => {
    state.loginDialogFlag =  loginDialogFlag
  },
  SET_TOKEN: (state, token) => {
    state.token =  token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo =  userInfo
  },
  SET_SPEAKER_MAP: (state, speakerMap) => {
    state.speakerMap =  speakerMap
  },
  SET_DUBBING_PARAMS: (state, dubbingParams) => {
    state.dubbingParams =  dubbingParams
  },
  SET_DUBBING_PRICE: (state, dubPrice) => {
    state.dubPrice =  dubPrice
  },
  SET_REGENERATE_FLAG: (state, regenerateFlag) => {
    state.regenerateFlag = regenerateFlag
  },
  SET_WALLET_INFO: (state, walletInfo) => {
    state.walletInfo = walletInfo
  },
  SET_DUBBING_ID: (state, dubbingID) => {
    state.dubbingID = dubbingID
  },
  SET_BAG_PAID: (state, bagPaid) => {
    state.bagPaid = bagPaid
  },
}

const actions = {
  setBagFlag({ commit }, showBagFlag) {
    console.log(showBagFlag, 'showBag')
    commit('SET_BAG_FLAG', showBagFlag)
  },
  setOrderFlag({ commit }, showOrderFlag) {
    console.log(showOrderFlag, 'showOrderFlag')
    commit('SET_ORDER_FLAG', showOrderFlag)
  },
  setVipFlag({ commit }, showVipFlag) {
    console.log(showVipFlag, 'showVipFlag')
    commit('SET_VIP_FLAG', showVipFlag)
  },
  setLoginDialogFlag({ commit }, loginDialogFlag) {
    console.log(loginDialogFlag, 'loginDialogFlag')
    commit('SET_LOGIN_DIALOG_FLAG', loginDialogFlag)
  },
  setToken({ commit }, token) {
    console.log(token, 'token')
    setToken(token)
    commit('SET_TOKEN', token)
  },
  setUserInfo({ commit }) {
    getUserInfo().then((res) => {
      const {common_free_dubbings, dubbing_package_free_dubbings, vip_monthly_free_dubbings} = res.data
      let userInfo = res.data
      // userInfo.vip_type = 3
      userInfo.total = common_free_dubbings + dubbing_package_free_dubbings + vip_monthly_free_dubbings
      userInfo.vip_end_date = userInfo.vip_type ? '有效期至：' + formatUnixTime(userInfo.vip_end_date) : 'VIP会员享受免费导出和分享特权'
      userInfo.vip_bg = require(`@/assets/images/nav/vip_${userInfo.vip_type}.png`)
      userInfo.vip_title = userInfo.vip_type ? `VIP${vipTypeMap[userInfo.vip_type]}会员` : '普通用户'
      userInfo.personal_vip_bg = require(`@/assets/images/personal/vip_${userInfo.vip_type}.png`)
      commit('SET_USER_INFO', userInfo);
    });
  },
  setSpeakerMap({ commit }, speakerMap) {
    console.log(speakerMap, 'speakerMap')
    commit('SET_SPEAKER_MAP', speakerMap)
  },
  setDubbingParams({ commit }, dubbingParams) {
    let newParams = dubbingParams
    if (!dubbingParams) {
      newParams = defaultDubbingParams
    }
    console.log(JSON.stringify(newParams), 'dubbingParams')
    localStorage.setItem("dubbingParams", JSON.stringify(newParams));
    commit('SET_DUBBING_PARAMS', newParams)
  },
  setDubPrice({ commit }, dubPrice) {
    console.log(JSON.stringify(dubPrice), 'dubPrice')
    commit('SET_DUBBING_PRICE', dubPrice)
  },
  setRegenerateFlag({ commit }, regenerateFlag) {
    console.log(regenerateFlag, 'regenerateFlag')
    commit('SET_REGENERATE_FLAG', regenerateFlag)
  },
  setWalletInfo({ commit }) {
    userWalletInfo().then((res) => {
      const { balance, withdrawal } = res.data
      const walletInfo = {
        balance: formatMoney(balance),
        withdrawal: formatMoney(withdrawal),
      }
      commit('SET_WALLET_INFO', walletInfo);
    });
  },
  setDubbingID({ commit }, dubbingID) {
    console.log(dubbingID, 'dubbingID')
    commit('SET_DUBBING_ID', dubbingID)
  },
  setBagPaid({ commit }, bagPaid) {
    console.log(bagPaid, 'bagPaid')
    commit('SET_BAG_PAID', bagPaid)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
